import React, { useContext, useState, useEffect } from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Loader from '../atoms/Loader/Loader';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
import CurrencySelector from '../102_ListingOffersAndDeals/components/CurrencySelector';
import { getColorByTheme, getPageThemeColors, get, canUseDOM, hexToRgb, getDictionaryItem } from '../../utils';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { convertToAnalyticObject } from '../../utils/analytics';
import { getHostName } from '../atoms/InteractiveMap/utils/getHostName';
import { LOCAL_STORAGE_APP_CURRENCY } from '../102_ListingOffersAndDeals/constants';
import useProfile from '../../utils/hooks/useProfile';
const OfferAndDealDetails = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const language = get(sitecoreContext, 'language') || 'en';
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const userProfile = useProfile();
  const [isVdsite, setIsVdsite] = useState(true);
  const [currencyIndex, setCurrencyIndex] = useState(0);
  const [currencyName, setCurrencyName] = useState('');
  const [deal, setDeal] = useState({});
  const [loading, setLoading] = useState(false);
  const host = canUseDOM ? window.location.hostname : '';
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const dictionary = get(fields, 'data.dictionary');
  const socialSharing = get(fields, 'data.socialSharing');
  const currencies = get(fields, 'data.settings.currencies.currencies', []);
  const indexName = get(fields, 'data.settings.searchIndex.jss.value', '');
  const OaDID = get(fields, 'data.item.id', '');
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const fromText = getDictionaryItem(dictionary, 'from') || '#';
  const offText = getDictionaryItem(dictionary, 'off') || '#';
  const expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  const moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  const bookNowText = getDictionaryItem(dictionary, 'bookNow') || '#';
  const termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  const pageTitle = getDictionaryItem(dictionary, 'dealsInDubai') || '#';
  const ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  const ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';

  /* Params elements */
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  /* End Params elements */

  const variables = BackgroundColorHex ? {
    "--offer-and-deal-details-background-color": BackgroundColorHex,
    "--offer-and-deal-details-background-color-rgb": hexToRgb(BackgroundColorHex, true),
    "--offer-and-deal-details-background-active-color": ActiveColorHex,
    "--offer-and-deal-details-color": ColorHex
  } : {
    "--offer-and-deal-details-background-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--offer-and-deal-details-background-color-rgb": hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
    "--offer-and-deal-details-background-active-color": primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--offer-and-deal-details-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(() => {
    const lsCurrency = localStorage.getItem(LOCAL_STORAGE_APP_CURRENCY);
    setCurrencyName(lsCurrency || 'AED');
  }, []);
  useEffect(() => {
    if (OaDID && indexName) {
      setLoading(true);
      const itemFilters = {
        filters: `(objectID:${OaDID.toLowerCase()})`
      };
      const indexLanguaged = `${getHostName(host)}${indexName}_${language}`;
      getListing(indexLanguaged, itemFilters, algoliaSettings).then(response => {
        setLoading(false);
        setDeal(response && response.hits && response.hits[0]);
      });
    }
  }, []);
  if (!deal || !deal.objectID) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: `
        {
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "${pageTitle}",
          "description": "",
          
          "offers": [
          ${Array.isArray(deal) ? deal.map(el => {
        return `{
                      "@type": "Offer",
                      "priceCurrency": "${currencyName}",
                      "price": "${el.price}",
                      "url": "${el.url}"
                    }`;
      }).join(',') : `{
                  "@type": "Offer",
                  "priceCurrency": "${currencyName}",
                  "price": "${deal.price}",
                  "url": "${deal.url}"
                }`}
          ]
        }`
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-8 col-sm-9 "
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageTitle && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: {
      value: pageTitle
    },
    className: "h2 c-title__text"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-4 col-sm-3 col-xl-2 pb-3"
  }, !!currencies.length && /*#__PURE__*/React.createElement(CurrencySelector, {
    changeCurrency: setCurrencyIndex,
    changeCurrencyName: setCurrencyName,
    currencyName: currencyName,
    currencies: currencies,
    rtl: rtl,
    themeVariables: variables
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, loading && /*#__PURE__*/React.createElement(Loader, {
    color: BackgroundColorHex || primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary
  }), deal && deal.objectID && /*#__PURE__*/React.createElement("div", {
    className: "row deals-grid--list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, /*#__PURE__*/React.createElement(OfferAndDeal, {
    userProfile: userProfile,
    fromText: fromText,
    offText: offText,
    expiresSoonText: expiresSoonText,
    moreInfoText: moreInfoText,
    bookNowText: bookNowText,
    termsAndConditionsText: termsAndConditionsText,
    deal: deal,
    rtl: rtl,
    currency: currencyName,
    currencyIndex: currencyIndex,
    gridMode: false,
    socialSharing: socialSharing,
    useTruncate: false,
    themeVariables: variables,
    eventsAnalytics: eventsAnalytics,
    params: params,
    ratingTextStars: ratingTextStars,
    ratingTextStar: ratingTextStar,
    countryItems: countryItems
  })))))));
};
const StyledWrapper = _ref2 => {
  let {
    rtl,
    children,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter
  }, children);
};
export default OfferAndDealDetails;